import Button from '@atlaskit/button';
import styled from '@emotion/styled';
import { B300, B500 } from '@atlaskit/theme/colors';

import React, { PropsWithChildren } from 'react';

type PricingExampleButtonProps = {
  highlighted?: boolean;
  disabled?: boolean;
  onClickHandler: () => void;
};

const PricingExampleButton = ({
  onClickHandler,
  children
}: PropsWithChildren<PricingExampleButtonProps>) => {
  return (
    <StyledButton appearance={'link'} onClick={() => onClickHandler()}>
      {children}
    </StyledButton>
  );
};

const StyledButton = styled(Button)`
  color: ${B300} !important;
  font-family: 'Charlie Text';
  font-size: 16px;
  font-weight: 400;
  text-decoration: underline;
  text-underline-offset: 4px;
  &:hover {
    color: ${B500} !important;
  }
`;

export { PricingExampleButton };
